<template>
    <v-dialog :value="showsAuth" persistent width="560">
        <v-card class="ma-0 black" dark tile v-bind="{ loading }">
            <v-card-text class="py-24">
                승인받지 않은 사용자의 참여 요청이 왔습니다. <br />
                참여를 승인하시겠습니까?

                <auth-seekers v-model="selected" class="mt-16" />
            </v-card-text>
            <v-card-actions class="px-24 pt-0 pb-16">
                <v-row>
                    <v-col>
                        <v-btn block color="secondary" v-bind="{ disabled }" @click="reject">거부하기</v-btn>
                    </v-col>
                    <v-col>
                        <v-btn block color="primary" v-bind="{ disabled }" @click="approve">승인하기</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import AuthSeekers from "./auth/auth-seekers.vue";

export default {
    components: {
        AuthSeekers,
    },
    data: () => ({
        selected: [],
    }),
    computed: {
        ...mapState("interview", ["loading"]),
        ...mapGetters("interview", ["showsAuth"]),
        disabled() {
            return this.selected.length < 1;
        },
    },
    methods: {
        ...mapActions("interview/server", ["auth"]),
        approve() {
            this.auth({ seekers: this.selected, isAuthorized: true });
        },
        reject() {
            this.auth({ seekers: this.selected, isAuthorized: false });
        },
    },
};
</script>

<style>
</style>